export const UPDATE_PRODUCTS = "UPDATE_PRODUCTS"; // these have been removed as reducers
export const UPDATE_LINKS = "UPDATE_LINKS";       // i think we can just make direct queries
export const UPDATE_POSTS = "UPDATE_POSTS";       // on the relevant page

export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_MULTIPLE_TO_CART = "ADD_MULTIPLE_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_CART = "CLEAR_CART";
export const UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
export const UPDATE_CART_LINES_INSTOCK = "UPDATE_CART_LINES_INSTOCK";
export const TOGGLE_CART = "TOGGLE_CART";

export const UPDATE_CATEGORIES = "UPDATE_CATEGORIES";
export const UPDATE_CURRENT_CATEGORY = "UPDATE_CURRENT_CATEGORY";

export const SET_USER = 'SET_USER';
export const LOGGED_IN_USER = 'LOGGED_IN_USER';

export const SIGNUP_MODAL_FLAG = 'SIGNUP_MODAL_FLAG';
export const SIGNUP_MODAL_DISMISSED = 'SIGNUP_MODAL_DISMISSED';
